import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Wrapper reutilizable para mostrar ejemplos en la app de documentación (no es parte del DS público).
 */
@Component({
  selector: 'app-example-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './ds-example-section.component.html',
  styleUrl: './ds-example-section.component.scss',
})
export class AppExampleSectionComponent {
  readonly title = input.required<string>();
  readonly description = input<string>();
}
